export default class Insurer {
    constructor(public id: number, public label: string, public slug: string, public logo: string) {
    }


}
